<div id="todo" class="page-layout carded left-sidebar inner-scroll">


    <div class="center">
        <div fxLayout="row wrap" style="overflow-y: scroll;">

            <div class="about-content p-24" fxLayout="column" fxFlex="100" fxFlex.gt-sm="100" fxFlex.gt-md="100">
                <div class="profile-box info-box general" fxLayout="column">
                    <header class="accent">
                        <div class="title">
                            {{ 'Group activity'|translate }} {{ reservation.startDate|date: 'dd.MM.y HH:mm':'UTC': locale }} - {{ reservation.endDate|date: 'dd.MM.y HH:mm':'UTC': locale }}

                            <button
                                    (click)="openAddParticipantDialog(reservation)"
                                    mat-button
                                    class="save-button"
                                    color="primary"
                            >{{'Add participant'|translate}}</button>
                        </div>
                    </header>

                    <div class="content">
                        <h2>
                            {{'Trainer'|translate}} {{reservation.groupActivity.trainer.firstName}} {{reservation.groupActivity.trainer.lastName}}
                        </h2>
                        <h3>
                            {{'Number of contestants'|translate}}: {{reservation.groupActivity.participants?reservation.groupActivity.participants.length:'0'}}
                            Potwierdziło: {{confirmedQuantity}}
                            Wzięło udział: {{trainedQuantity}}
                        </h3>
                        <table class="table" *ngIf="reservation.groupActivity.participants && reservation.groupActivity.participants.length>0">
                            <thead>
                            <tr>
                                <th>
                                    {{'Participant'|translate}}
                                </th>
                                <th>
                                    {{'Phone number'|translate}}
                                </th>
                                <th>
                                    {{'E-mail'|translate}}
                                </th>
                                <th>
                                    {{'Confirmed'|translate}}
                                </th>
                                <th>
                                    {{'Took part in'|translate}}
                                </th>
                                <th style="text-align: center;">
                                    {{'Actions'|translate}}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let participant of reservation.groupActivity.participants">
                                <td>{{participant.customer.firstName}} {{participant.customer.lastName}}</td>
                                <td>{{participant.customer.phone}}</td>
                                <td>{{participant.customer.email}}</td>
                                <td>
                                    {{participant.confirmed?('Yes'|translate):('No'|translate)}}
                                </td>
                                <td>
                                    {{participant.tookPartIn?('Yes'|translate):('No'|translate)}}
                                </td>
                                <td>
                                    <button
                                            *ngIf="!participant.confirmed"
                                            (click)="markAsConfirmed(participant)"
                                            mat-button
                                            class="save-button"
                                            color="primary"
                                    >{{'Confirm your willingness to participate'|translate}}</button>

                                    <button
                                            *ngIf="!participant.tookPartIn"
                                            (click)="markAsTookPartIn(participant)"
                                            mat-button
                                            class="save-button"
                                            color="primary"
                                    >{{'Took part in'|translate}}</button>

                                    <button
                                            (click)="openDeleteParticipantDialog(reservation.groupActivity, participant)"
                                            mat-button
                                            class="mr-8"
                                            aria-label="Delete"
                                            color="warn"
                                    >{{'Delete participant'|translate}}</button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>

    </div>
</div>
